import { Box } from '#/components/Box/Box';
import { Image } from '#/components/Image/Image';
import { useAppConfig } from '#/config/AppConfigContext';
import { getStaticImageSrc } from '#/utils/getImageSrc';

type Props = {
  isAmex?: boolean;
};

export function CreditCardBrandImage({ isAmex }: Props) {
  const { appConfig } = useAppConfig();

  return (
    <Box
      component={Image}
      src={
        isAmex
          ? getStaticImageSrc('cc-amex.svg', appConfig.idealist.staticImgPath)
          : getStaticImageSrc('cc-other.svg', appConfig.idealist.staticImgPath)
      }
      alt=""
    />
  );
}
